
































































































import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import FormErrors from "@/lib/components/FormErrors.vue";

import dataStore from "@/store";
import { Resource } from "@/modules/account/resource";
import AuthenticatedUserProvider from "@/modules/account/authenticated-user-provider.service";
import ErrorConverterService from "@/modules/forms/error-converter.service";
import AuthenticatedUser from "@/modules/account/authenticated-user.model";

import { FactoryInvoiceTypeValue } from "../../factory-invoice-type.value";
import InvoiceItem from "../../invoice-item.model";
import FactoryInvoiceStore from "../../store/index";
import FactoryInvoice from "../../factory-invoice.model";
import { FactoryInvoiceStatusValue } from "../../factory-invoice-status.value";

@Component({
  components: {
    FormErrors,
  },
})
export default class FactoryInvoiceViewDetails extends Vue {
  @Prop({ required: true })
  public readonly invoiceId!: string;

  @Prop({ default: false })
  public readonly isBatchScope!: boolean;

  @Inject("AuthenticatedUserProvider")
  private fUserProvider!: AuthenticatedUserProvider;

  @Inject("ErrorConverterService")
  private fErrorConverterService!: ErrorConverterService;

  private fFactoryInvoiceStore: FactoryInvoiceStore;

  private fErrorsList: string[] = [];
  private fIsDisabled = false;

  get errorsList(): string[] {
    return this.fErrorsList;
  }

  get isDisabled(): boolean {
    return this.fIsDisabled;
  }

  get invoice(): FactoryInvoice | undefined {
    return this.fFactoryInvoiceStore.getFactoryInvoiceById(this.invoiceId);
  }

  get invoiceItems(): InvoiceItem[] {
    const items = this.fFactoryInvoiceStore.getInvoiceItemsByInvoiceId(
      this.invoiceId
    );

    items.sort((a, b) =>
      (a.plushieNameForFactory || "") > (b.plushieNameForFactory || "") ? 1 : -1
    );

    return items;
  }

  get isDepositInvoice(): boolean {
    return this.invoice?.type === FactoryInvoiceTypeValue.DEPOSIT;
  }

  get showAppliedDepositPercent(): boolean {
    return (
      !this.isBatchScope &&
      this.isDepositInvoice &&
      this.invoiceItems.some((item) => item.usagePercent !== undefined)
    );
  }

  get showDepositDeduction(): boolean {
    return (
      !this.isBatchScope &&
      (this.invoice?.type === FactoryInvoiceTypeValue.SHIPMENT ||
        this.invoice?.type === FactoryInvoiceTypeValue.PERIODICAL) &&
      this.invoiceItems.some((item) => item.depositDeduction !== undefined)
    );
  }

  get canManagePenalties(): boolean {
    if (this.isBatchScope || this.isDepositInvoice || !this.invoice) {
      return false;
    }

    if (this.invoice.status !== FactoryInvoiceStatusValue.REVIEW) {
      return false;
    }

    const user = this.fUserProvider.getUser();

    if (!user) {
      return false;
    }

    return user.hasPermissionForResource(Resource.FACTORY_INVOICE_APPROVE);
  }

  get isFactoryView(): boolean {
    const user = this.fUserProvider.getUser();

    if (!user) {
      return true;
    }

    return user.role === AuthenticatedUser.ROLE_FACTORY;
  }

  constructor() {
    super();

    this.fFactoryInvoiceStore = getModule(FactoryInvoiceStore, dataStore);
  }

  public getItemName(item: InvoiceItem): string {
    if (this.isFactoryView) {
      return item.plushieNameForFactory || "";
    }

    return item.plushieName || "";
  }

  public async togglePenalty(item: InvoiceItem): Promise<void> {
    if (this.isBatchScope || this.isDepositInvoice) {
      return;
    }

    this.fIsDisabled = true;

    try {
      await this.fFactoryInvoiceStore.updateFactoryInvoiceItem({
        id: item.id,
        applyPenalty: !item.applyPenalty,
      });
    } catch (e) {
      const errors = this.fErrorConverterService.describeError(e);
      this.fErrorsList.push(...errors);
    } finally {
      this.fIsDisabled = false;
    }
  }
}
